/**
 * useListingPreferenceBootstrap — derives initial state values from loaded
 * preferences or page-specific defaults.
 *
 * A2 from listing-abstraction-opportunities.md
 *
 * Hydrates three pieces of initial state for a listing page:
 *   - initialActiveFilterKeys
 *   - initialVisibleColumnKeys
 *   - initialQueryState (page, sort, filters, search)
 *
 * This is a pure-compute hook (no side-effects) — it runs once at mount and
 * the caller uses the returned values as initializers for useState /
 * useListingQueryState.
 */
import { useRef } from 'react';
import { sanitizeColumns } from './columnPreferences';
function computeBootstrap(options) {
    var _a, _b, _c, _d;
    const { preferences, defaultActiveFilterKeys, columnPolicy, defaultFilters, defaultSort, defaultPageSize = 25, includeSearch = false } = options;
    return {
        initialActiveFilterKeys: (_a = preferences === null || preferences === void 0 ? void 0 : preferences.activeFilterKeys) !== null && _a !== void 0 ? _a : [...defaultActiveFilterKeys],
        initialVisibleColumnKeys: sanitizeColumns((_b = preferences === null || preferences === void 0 ? void 0 : preferences.visibleColumnKeys) !== null && _b !== void 0 ? _b : [...columnPolicy.defaults], columnPolicy),
        initialPageSize: (_c = preferences === null || preferences === void 0 ? void 0 : preferences.pageSize) !== null && _c !== void 0 ? _c : defaultPageSize,
        initialSort: (_d = preferences === null || preferences === void 0 ? void 0 : preferences.sort) !== null && _d !== void 0 ? _d : defaultSort,
        initialFilters: preferences ? Object.assign(Object.assign({}, defaultFilters), preferences.filters) : defaultFilters,
        initialSearch: includeSearch ? '' : undefined
    };
}
export function useListingPreferenceBootstrap(options) {
    const bootstrappedRef = useRef(null);
    if (!bootstrappedRef.current) {
        bootstrappedRef.current = computeBootstrap(options);
    }
    return bootstrappedRef.current;
}
